import { mapGetters } from 'vuex'
import TopEntries from "../../components/home/dashboard/summary/TopEntries";

export function getListNameFromType({ listType }) {
    return listType === 'buy' ? 'buyLists' : listType === 'sell' ? 'sellLists' : 'portfolios';
}

export function getTopList(lists, count) {
    const topEntries = new TopEntries();
    lists.forEach(list => {
        var entries = list.entries;
        entries.forEach(entry => {
            topEntries.addEntry({
                stock: entry,
                list: list
            });
        });
    });
    return topEntries.getTop(count);
}

export const listComputed = {
    ...mapGetters(['buyListsLoaded', 'sellListsLoaded', 'portfoliosLoaded', 'userLists'])
}